
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { EventForm } from "@/components/create-event/EventForm";
import { useEventForm } from "@/hooks/use-event-form";

const CreateEvent = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate('/login');
        toast({
          title: "Authentication required",
          description: "Please log in to create an event",
          variant: "destructive",
        });
      }
    };
    checkAuth();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <EventForm />
    </div>
  );
};

export default CreateEvent;
